import { FC } from 'react';
import { faPlus } from '~/assets';
import { PaginatedList, TitlePage, UploadRow } from '~/components';
import { uploadsColumns } from '~/utils';
import {
  ButtonRegisterProduct,
  ContentBox,
  IconPlus,
  TopBox,
  Wrapper,
} from './styles';

type Props = {
  isFilesLoading: boolean;
  filesList: ListResponse<FileUpload>;
  isUserEspectator: boolean;
  onChangePage(page: number): void;
  onPressFile(product: FileUpload): void;
  onPressUploadFile: () => void;
};

const Files: FC<Props> = ({
  filesList,
  isFilesLoading,
  isUserEspectator,
  onChangePage,
  onPressFile,
  onPressUploadFile,
}) => (
  <Wrapper titlePage="Importações">
    <ContentBox>
      <TopBox>
        <TitlePage totalElements={filesList.paging?.totalElements}>
          Importações
        </TitlePage>
        <ButtonRegisterProduct
          id="btn_register_product"
          disabled={isUserEspectator}
          onPress={onPressUploadFile}
          secondary
        >
          <IconPlus icon={faPlus} />
          Fazer Upload
        </ButtonRegisterProduct>
      </TopBox>

      <PaginatedList
        columns={uploadsColumns}
        list={filesList.content}
        totalPages={filesList.paging?.totalPages}
        currentPage={filesList.paging?.page}
        isLoading={isFilesLoading}
        onChangePage={onChangePage}
        renderList={(file: FileUpload) => (
          <UploadRow
            name={file?.fileName}
            status={file?.status}
            type={file?.type}
            createdAt={new Date(file?.createdAt)}
            onPress={() => onPressFile(file)}
            key={`${file?.createdAt}`}
          />
        )}
        titleEmptyData="Sem uploads disponíveis"
      />
    </ContentBox>
  </Wrapper>
);

export default Files;
